import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import {
  Avatar,
  Col,
  Row as AntRow,
  Empty,
  Form,
  Pagination,
  Select,
} from "antd";
import { ButtonOutlined } from "reusableComponent/UIButtons";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import moment from "moment";
import { filter, find, inRange, some, startCase, uniqBy } from "lodash";
import styled from "styled-components";
import COLORS from "common/Colors";
import { useHistory } from "react-router-dom";
import UIModal from "reusableComponent/UIModal";
import AddDateModal from "./AddDateModal";
import queryKeys from "common/queryKey";
import { useFetch } from "hooks/useFetch";
import { findWeekId } from "utils/Date";
import { DropdownCheckBox } from "atoms/UIDropdown/Dropdown";
import { getUserInfo, getUserList, getCountryList } from "redux/selectors";
import { useSelector } from "react-redux";
import { useQueryState } from "hooks/useQueryState";
import {
  STATUS_CODE,
} from "common/Constants";
import { CALL_AI_API, CALL_API } from "common/API";
import axios from "axios";
import { Option } from "antd/lib/mentions";

export const StyledAvatar = styled(Avatar)`
  margin-right: 0.5rem;
  margin-bottom: 5px;
  background-color:#DEEFEE;
  vertical-align: middle;
  color: #000000;
`;

function Row(props) {
  const { row, weekDates, index, dataList, userList, getData } = props;

  const [open, setOpen] = React.useState(false);
  const [openindex, setInndex] = React.useState(false);
  const [openEditModal, setOpenEditModal] = React.useState(false);
  const [editData, setEditData] = React.useState({});
  const [editDate, setEditDate] = React.useState({});
  const [selectedDate, setSelectedDate] = React.useState({});

  const { getAllClientFiltered } = queryKeys;
  const { isFetched: isClientsFetched } = useQueryState(
    getAllClientFiltered?.key
  );
  const { data: clientDataRes } = useFetch(
    getAllClientFiltered?.key,
    getAllClientFiltered?.url,
    { enabled: !isClientsFetched }
  );
  const clientList = clientDataRes?.data || [];

  const getClientName = (clientId) => {
    const matchedClients = clientList.filter((c) => c.bdo_id === clientId);
    return matchedClients.length > 0
      ? matchedClients.map((c) => c.name).join(", ")
      : "";
  };

  const calculatePercentage = (value) => {
    const total = 8;
    const percentage = (value / total) * 100;
    return percentage;
  };

  const userProfile = find(userList, { userid: row?.userId });
  const profileUrl = userProfile ? userProfile.profileurl : null;
  const usersClientList = filter(dataList, { userId: row?.userId });
  const listEngagementList = uniqBy(usersClientList, "matterId");

  const history = useHistory(); // Initialize useHistory hook

  const handleCellClick = () => {
    history.push("/create-matter"); // Navigate to '/engagement' route when cell is clicked
  };

  const handleOpenModal = (row, weekIndex, date) => {
    const userProfile = find(userList, { userid: row?.userId });
    const profileUrl = userProfile ? userProfile.profileurl : null;
    const rowWithProfile = { ...row, profileurl: profileUrl };
    setEditData(rowWithProfile);
    let maxCount = 0;
    const slicedArray = weekDates.slice(weekIndex, 5);
    slicedArray.forEach((date) => {
      const isWithinAnyRange = some(usersClientList, (entry) => {
        const startDate = moment(entry?.bookedStartDate);
        const endDate = moment(entry?.bookedEndDate).add(1, "day");
        return inRange(date, startDate, endDate);
      });
      if (!isWithinAnyRange) {
        maxCount += 1;
      }
    });
    setSelectedDate(date);

    setEditDate(maxCount);
    setOpenEditModal(true);
  };
  let dailyTotalBookedMap = {};

  

  return (
    <React.Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell
          className="pointer"
          onClick={() => {
            setOpen(!open);
            setInndex(index);
          }}
        >
          <div className="profile-area">
            {profileUrl ? (
              <StyledAvatar src={profileUrl} size="default"></StyledAvatar>
            ) : (
              <StyledAvatar size="default">
                {startCase(row?.employeeName).charAt(0)}
              </StyledAvatar>
            )}

            {/* <img className="profile-img" src={row.profile} alt="profile" /> */}
            <span className="profile-name">
              {row?.employeeName}
              <div className="role">{row?.projectRole}</div>
            </span>
          </div>
        </TableCell>
        {weekDates
          .filter(
            (date) => moment(date).day() !== 0 && moment(date).day() !== 6
          ) // Exclude weekends
          .map((date, dateIndex) => {
            const isBetween = some(usersClientList, (entry) => {
              const startDate = moment(entry?.actualBookedStartDate);
              const endDate = moment(entry?.actualBookedEndDate).add(1, "day");
              return inRange(date, startDate, endDate);
            });

            const isWeekend =
              moment(date).day() === 0 || moment(date).day() === 6;

              const isOverAllocated =
  isBetween &&
  !isWeekend &&
  Math.round(
    (usersClientList.reduce((acc, entry) => {
      const startDate = moment(entry?.actualBookedStartDate);
      const endDate = moment(entry?.actualBookedEndDate).add(1, "day");

      if (inRange(date, startDate, endDate)) {
        const totalDays = endDate.diff(startDate, "days");
        const bookedHours =
          (parseInt(entry?.personDay || 0) * 8) / totalDays;
        return acc + bookedHours;
      }
      return acc;
    }, 0) /
      8) *
      100
  ) > 100;

            return (
              <TableCell
                key={dateIndex}
                className={`percentagedata-cell ${isWeekend ? "weekend-cell" : isBetween ? "null-cell" : ""
                  }`}
                style={{
                  backgroundColor:
                    isBetween &&
                      !isWeekend &&
                      Math.round(
                        (usersClientList.reduce((acc, entry) => {
                          const startDate = moment(entry?.actualBookedStartDate);
                          const endDate = moment(entry?.actualBookedEndDate).add(
                            1,
                            "day"
                          );
                          if (inRange(date, startDate, endDate)) {
                            const totalDays = endDate.diff(startDate, "days");
                            const bookedHours =
                              (parseInt(entry?.personDay || 0) * 8) / totalDays;
                            return acc + bookedHours;
                          }
                          return acc;
                        }, 0) /
                          8) *
                        100
                      ) > 100
                      ? "#CA1003"
                      : "",
                }}
              >
                <span style={{ color: isOverAllocated ? "#fff" : "" }}>
                  {" "}
                  {isBetween && !isWeekend
                    ? Math.round(
                      (usersClientList.reduce((acc, entry) => {
                        const startDate = moment(
                          entry?.actualBookedStartDate
                        );
                        const endDate = moment(
                          entry?.actualBookedEndDate
                        ).add(1, "day");
                        if (inRange(date, startDate, endDate)) {
                          const totalDays =
                            endDate.diff(startDate, "days") || 1; // Ensure totalDays is at least 1
                          const bookedHours =
                            (parseInt(entry?.personDay || 0) * 8) / totalDays;
                          return acc + (isNaN(bookedHours) ? 0 : bookedHours);
                        }
                        return acc;
                      }, 0) /
                        8) *
                      100 // Use the provided formula for percentage calculation
                    )
                    : 0}
                  %
                </span>
                <span style={{ color: isOverAllocated ? "#fff" : "" }}>({isBetween && !isWeekend ? 8 : 0} hrs)</span>
              </TableCell>
            );
          })}
      </TableRow>
      {openindex === index && open && (
        <>
          {listEngagementList?.map((client, clientIndex) => (
            <TableRow key={clientIndex}>
              {/* Engagement Name & Client Name in the same row */}
              <TableCell
                className="pointer"
                style={{ display: "flex", flexDirection: "column" }}
                onClick={handleCellClick}
              >
                {client?.matterName} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                {/** Adds space */}
                <p className="mt-5" style={{ fontWeight: 600 }}>
                  {getClientName(client?.clientId)}
                </p>
              </TableCell>

              {/* Week Data Cells */}
              {weekDates
                .filter(
                  (date) => moment(date).day() !== 0 && moment(date).day() !== 6
                ) // Exclude weekends
                .map((date, weekIndex) => {
                  const filteredEngagementList = filter(usersClientList, {
                    matterId: client?.matterId,
                  });

                  const isBetween = some(filteredEngagementList, (entry) => {
                    const startDate = moment(entry?.actualBookedStartDate);
                    const endDate = moment(entry?.actualBookedEndDate).add(
                      1,
                      "day"
                    );
                    return inRange(date, startDate, endDate);
                  });

                  let totalBooked = 0;

                  filteredEngagementList.forEach((entry) => {
                    const startDate = moment(entry?.actualBookedStartDate);
                    const endDate = moment(entry?.actualBookedEndDate).add(
                      1,
                      "day"
                    );
                    if (inRange(date, startDate, endDate)) {
                      const daysBetween = endDate.diff(startDate, "days");
                      totalBooked +=
                        (parseInt(entry?.personDay || 0) * 8) / daysBetween;
                    }
                  });

                  totalBooked = isNaN(totalBooked) ? 0 : totalBooked;
                  // Add to global map for that date
                  if (!dailyTotalBookedMap[date]) {
                    dailyTotalBookedMap[date] = 0;
                  }
                  dailyTotalBookedMap[date] += totalBooked;

                  return (
                    <TableCell key={weekIndex} className="data-cell">
                      {isBetween ? (
                        <>
                          <div className="data-cell-value">
                            {totalBooked && !isNaN(totalBooked)
                              ? totalBooked % 1 === 0
                                ? Math.round(totalBooked)
                                : totalBooked.toFixed(2)
                              : 0}{" "}
                            hr - booked
                          </div>
                        </>
                      ) : null}
                    </TableCell>
                  );
                })}
            </TableRow>
          ))}

          <TableRow>
            <TableCell className="available-row-header">
              Total Available Hours
            </TableCell>
            {weekDates.map((date, weekIndex) => {
              const isWeekend =
                moment(date).day() === 0 || moment(date).day() === 6;

              const totalBooked = dailyTotalBookedMap[date] || 0;
              let availableHours = 0;
              let label = "";
              let bgColor = "";

              if (totalBooked > 8) {
                availableHours = totalBooked - 8;
                label = "hr - overbooked";
                bgColor = "rgb(255, 224, 224)"; // red-ish
              } else {
                availableHours = 8 - totalBooked;
                label = "hr - available";
                bgColor = "rgb(228, 250, 231)"; // green-ish
              }

              return (
                <TableCell
                  key={weekIndex}
                  className={isWeekend ? "weekend-cell" : "data-cell"}
                >
                  {!isWeekend && (
                    <div
                      className="data-cell-value"
                      style={{ backgroundColor: bgColor }}
                    >
                      {availableHours % 1 === 0
                        ? Math.round(availableHours)
                        : availableHours.toFixed(2)}{" "}
                      {label}
                    </div>
                  )}
                </TableCell>
              );
            })}
          </TableRow>

          {/* Assign New Engagement Row */}
          <TableRow>
            <TableCell className="addclient" onClick={handleCellClick}>
              +Assign New Engagement
            </TableCell>
            {weekDates
              .filter(
                (date) => moment(date).day() !== 0 && moment(date).day() !== 6
              ) // Exclude weekends
              .map((date, weekIndex) => {
                const isWeekend =
                  moment(date).day() === 0 || moment(date).day() === 6;
                return (
                  <TableCell
                    key={weekIndex}
                    className={isWeekend ? "weekend-cell" : "data-cell"}
                  ></TableCell>
                );
              })}
          </TableRow>
        </>
      )}

      <UIModal
        open={openEditModal}
        onClose={() => {
          setOpenEditModal(!openEditModal);
        }}
        header={<div></div>}
        size="sm"
      >
        <AddDateModal
          goBack={() => setOpenEditModal(!openEditModal)}
          Editdata={editData}
          EditDate={editDate}
          selectedDate={selectedDate}
          getData={getData}
        />
      </UIModal>
      {/* <AlertModal
        isModalOpen={openEditModal}
        handleCancel={() => setOpenEditModal(false)}
        handleOk={handleEdit}
        name={"Are you sure you want to extend the day?"}
        loading={loading}
      /> */}
    </React.Fragment>
  );
}

export default function PeoplePlanning({ userList }) {
  const [form] = Form.useForm();
  const [weekDates, setWeekDates] = React.useState([]);
  const [dataList, setDataList] = React.useState([]);
  const [uniqDataList, setUniqDataList] = React.useState([]);
  const [selectedEmployee, setSelectedEmployee] = React.useState([]);
  const [selectedEnagement, setSelectedEnagement] = React.useState([]);
  const [currentPage, setCurrentPage] = React.useState(1);
  const userInfo = useSelector((state) => getUserInfo(state));
  const countryList = useSelector(getCountryList);
  const [resourcePlanningList, setResourcePlanningList] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);

  const managingOffice = userList?.find(
    (user) => user.userid === userInfo?.userid
  )?.managingoffice?.[0];
  const [startDate, setStartDate] = React.useState(moment().startOf("isoWeek"));
  const [countryFieldValue, setCountryFieldValue] = React.useState(
    managingOffice === "Head Office" ? countryList[0]?.countryname : managingOffice
  );
  const [selectedServiceLine, setSelectedServiceLine] = React.useState([]);
  const [selectedPersonInCharge, setSelectedPersonInCharge] = React.useState(
    []
  );
  const [selectedPartner, setSelectedPartner] = React.useState([]);
  const [selectedCompetency, setSelectedCompetency] = React.useState([]);
  const { getResourePlanningList } = queryKeys;

  const weekId = findWeekId(weekDates[0], weekDates[6]);

  const concatenatedValue = `${weekId},${selectedEmployee.join(
    ","
  )},${selectedEnagement.join(",")}`;

  const { key, url } = getResourePlanningList(concatenatedValue);
  // REACT_QUERY_API_CALL
  // const {
  //   data: resourcePlanningList,
  //   isLoading,
  //   refetch,
  // } = useFetch(
  //   key,
  //   url,
  //   {
  //     enabled: !!weekId,
  //   },
  //   {
  //     startDate: new Date(moment(weekDates[0]).format("YYYY-MM-DD")),
  //     endDate: new Date(moment(weekDates[6]).format("YYYY-MM-DD")),
  //     // startDate: "2020-07-01T00:00:00.000Z",
  //     // endDate: "2021-06-30T00:00:00.000Z",
  //     employeeIds: [],
  //     engagementIds: selectedEnagement,
  //     weekId: [weekId],
  //     resourceId: [],
  //     managingOffice: countryFieldValue || managingOffice,
  //   }
  // );

  React.useEffect(() => {
    form.setFieldsValue({ country: [countryList[0]?.countryname] });
    fetchResorcePlanning();
  }, []);

  React.useEffect(() => {
    fetchResorcePlanning();
  }, [
    countryFieldValue,
    managingOffice,
    ,
    selectedEnagement,
    weekDates,
    weekId,
  ]);

  React.useEffect(() => {
    if (
      resourcePlanningList?.response?.response?.filter(
        (item) => item.employeeId !== "NA"
      )
    ) {
      getData(
        resourcePlanningList?.response?.response?.filter(
          (item) => item.employeeId !== "NA"
        )
      );
    }
    setCurrentPage(1);
  }, [resourcePlanningList, selectedEmployee]);

  React.useEffect(() => {
    setWeekDates(generateWeekdays());
  }, [startDate]);

  const generateWeekdays = () => {
    const startOfWeek = moment(startDate).startOf("isoWeek");
    const days = [];
    for (let i = 0; i < 7; i++) {
      days.push(moment(startOfWeek).add(i, "days"));
    }
    return days;
  };

  const handlePreviousWeek = () => {
    setStartDate(moment(startDate).subtract(1, "week"));
  };

  const handleNextWeek = () => {
    setStartDate(moment(startDate).add(1, "week"));
  };

  const fetchResorcePlanning = async () => {
    try {
      setIsLoading(true);
      const startDate = new Date(moment(weekDates[0]).format("YYYY-MM-DD"));
      const endDate = new Date(moment(weekDates[6]).format("YYYY-MM-DD"));
      const requestData = {
        startDate: startDate.toISOString(),
        endDate: endDate.toISOString(),
        employeeIds: [],
        engagementIds: selectedEnagement,
        weekId: [weekId],
        resourceId: [],
        managingOffice: countryFieldValue || managingOffice,
      };
      const response = await axios.post(
        "https://axcxv4d066.execute-api.ap-south-1.amazonaws.com/Prod/insyts/resource-plan",
        requestData,
        {
          headers: {
            Insytsjwt: window.localStorage.getItem("token") || "",
          },
        }
      );
      setResourcePlanningList(response.data);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching resource planning:", error);
    }
  };

  const filterdUserData = userList?.filter((user) => {
    const userOffice = user?.managingoffice?.[0];
    return userOffice === managingOffice && user?.statusid === "1";
  });

   const transformedUserData = filterdUserData
    ?.filter((user) => {
      // ✅ Only include ACTIVE users in Resource Planning
      return user?.statusid === "1";
    })
    ?.map((user) => ({
      effort: "",
      employeeName: user.fullname || "",
      employeeId: user.employeeid || "",
      matterName: "",
      actualBookedEndDate: "",
      resourceId: "",
      projectRole: "",
      personDay: "",
      status: user.statusname || "",
      createdAt: "",
      accessRole: null,
      engagementStartDate: "",
      clientId: user.clientid || "KE-2025-A0",
      matterId: "",
      userId: user.userid || "",
      managingOffice: user.managingoffice?.[0] || "",
      justification: "",
      updatedAt: "",
      actualBookedStartDate: "",
      engagementEndDate: "",
      resourceExtRate: null,
      remarks: null
    }));

  // 2. UPDATE getData function (around line 458-482):
  const getData = async (response) => {
    let res = uniqBy(response, "resourceId");
 
    res = res.filter((val) => val?.managingOffice === managingOffice);

    // ✅ CRITICAL FIX: Filter out terminated/inactive users from resource planning
    res = res.filter((val) => {
      const user = userList?.find((u) => u.userid === val?.userId);
      // Only include users with statusid === "1" and statusname === "active"
      return user?.statusid === "1";
    });

    let combinedData = [...res, ...transformedUserData];
    setDataList(combinedData);

    if (Array.isArray(selectedEmployee) && selectedEmployee.length > 0) {
      res = res.filter((val) => selectedEmployee.includes(val?.userId));
    }

    setUniqDataList(combinedData);
  };

  const iconStyle = { padding: "0 10px", margin: "0" };

  const handleFormChange = (selectedCountry) => {
    const values = form.getFieldsValue();
    setSelectedEmployee(values?.employee || []);
    setSelectedEnagement(values?.engagement || []);
    setSelectedServiceLine(values?.serviceLine || []);
    setSelectedPersonInCharge(values?.personInCharge || []);
    setSelectedCompetency(values?.competency || []);
    setSelectedPartner(values?.partner || []);
    if (form.getFieldValue("country")?.length > 0) {
      setCountryFieldValue(form.getFieldValue("country")?.[0]);
    } else {
      setCountryFieldValue("Head Office");
    }
  };

  const updatedDataList = uniqDataList.map((row) => {
    const user = userList.find((user) => user.userid === row.userId);
    return {
      ...row,
      userDetails: user || {},
    };
  });

  const pageSize = 10;
  const filteredData = uniqDataList.filter((row) => {
    const user = userList.find((u) => u.userid === row.userId);

    // ✅ CRITICAL: Only show ACTIVE users in Resource Planning
    const isActive = user?.statusid === "1";

    // If user is not active, exclude from list completely
    if (!isActive) {
      return false;
    }

    // Apply other filters
    const isSelectedEmployee = selectedEmployee.length === 0 || selectedEmployee.includes(row.userId);
    const isSelectedEngagement = selectedEnagement.length === 0 || selectedEnagement.includes(row.matterId);
    const isSelectedServiceLine = selectedServiceLine.length === 0 || selectedServiceLine.includes(row.serviceLine);
    const isSelectedCompetency = selectedCompetency.length === 0 || selectedCompetency.includes(row.competency);
    const isSelectedPersonInCharge = selectedPersonInCharge.length === 0 || selectedPersonInCharge.includes(row.employeeName);
    const isSelectedPartner = selectedPartner.length === 0 || selectedPartner.includes(row.employeeName);

    return (
      isSelectedEmployee &&
      isSelectedEngagement &&
      isSelectedServiceLine &&
      isSelectedCompetency &&
      isSelectedPersonInCharge &&
      isSelectedPartner
    );
  });
  // Show only one row per userId+projectRole, but allow multiple if projectRole differs
  const dedupedData = uniqBy(filteredData, "userId");

  const paginatedData = dedupedData.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  const paginationOptions = {
    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
    pageSize,
    showSizeChanger: false,
  };

  return (
    <>
      <div className="table-header">
        <Form form={form} layout="vertical" onValuesChange={handleFormChange}>
          <AntRow
            gutter={[16, 24]}
            style={{ display: "flex", flexWrap: "wrap" }}
          >
            <Col span={8} style={{ minWidth: "220px" }}>
              <DropdownCheckBox
                form={form}
                name="employee"
                label="Filter by Employee"
                options={uniqBy(
                  dataList
                    ?.filter((item) => {
                      const user = userList.find(
                        (user) => user.userid === item.userId
                      );
                      return user?.statusid === "1"; // Only include users with statusid === "1"
                    })
                    .map((item) => ({
                      label: item.employeeName,
                      value: item.userId,
                    })),
                  "value"
                )}
                handleFormChange={handleFormChange}
              />
            </Col>
            <Col span={8} style={{ minWidth: "220px" }}>
              <DropdownCheckBox
                form={form}
                name="engagement"
                label="Filter by Matter"
                options={uniqBy(
                  dataList
                    ?.filter((item) => item.matterId)
                    .map((item) => ({
                      label: item.matterName,
                      value: item.matterId,
                    })),
                  "value"
                )}
                handleFormChange={handleFormChange}
              />
            </Col>
            {/* <Col span={8} style={{ minWidth: "220px" }}>
              <DropdownCheckBox
                form={form}
                name="serviceLine"
                label="Filter by Practice Area"
                options={uniqBy(
                  dataList
                    ?.filter((item) => item?.serviceLine)
                    .map((item) => ({
                      label: item?.serviceLine,
                      value: item?.serviceLine,
                    })),
                  "value"
                )}
                handleFormChange={handleFormChange}
              />
            </Col> */}
            <Col span={8} style={{ minWidth: "220px" }}>
              <DropdownCheckBox
                form={form}
                name="partner"
                label="Filter by Lead Attorney"
                options={uniqBy(
                  dataList
                    ?.filter((item) => item?.projectRole === "Lead Attorney")
                    .map((item) => ({
                      label: item?.employeeName,
                      value: item?.employeeName,
                    })),
                  "value"
                )}
                handleFormChange={handleFormChange}
              />
            </Col>
            <Col span={8} style={{ minWidth: "220px" }}>
              <DropdownCheckBox
                form={form}
                name="personInCharge"
                label="Filter by Referring Attorney"
                options={uniqBy(
                  dataList
                    ?.filter((item) => item?.projectRole === "Referring Attorney")
                    ?.map((item) => ({
                      label: item?.employeeName,
                      value: item?.employeeName,
                    })),
                  "value"
                )}
                handleFormChange={handleFormChange}
              />
            </Col>
            {/* <Col span={8} style={{ minWidth: "220px" }}>
              <DropdownCheckBox
                form={form}
                name="competency"
                label="Filter by Sub Practice Area"
                options={uniqBy(
                  dataList
                    ?.filter((item) => item?.competency)
                    .map((item) => ({
                      label: item?.competency,
                      value: item?.competency,
                    })),
                  "value"
                )}
                handleFormChange={handleFormChange}
              />
            </Col> */}
            {/* REUSE_IFNEEDED_CHECKBOX_DROPDOWN */}
            {/* {managingOffice === "Head Office" &&
              <Col span={8} style={{ minWidth: "220px" }}>
                <DropdownCheckBox
                  form={form}
                  name="country"
                  label="Filter by Country"
                  mode="false"
                  options={uniqBy(
                    form.getFieldValue("country")?.length > 0
                      ? CountryFilterResourcePlanning.filter(
                        (item) => item?.country === form.getFieldValue("country")?.[0]
                      ).map((item) => ({
                        label: item.country,
                        value: item.country,
                      }))
                      : CountryFilterResourcePlanning.map((item) => ({
                        label: item.country,
                        value: item.country,
                      })),
                    "value"
                  )}
                  onChange={(value) => {
                    form.setFieldsValue({ country: value ? [value] : [] });
                    handleFormChange(value); // Ensure state update before API call
                  }}
                  disableClearAndSelectAll={false}
                />
              </Col>
            } */}
            {managingOffice === "Head Office" && (
              <Col span={8} style={{ minWidth: "220px" }}>
                <BorderRadiusSelect
                  className="rounded-select"
                  allowClear
                  style={{ width: "100%", borderRadius: "20px" }}
                  placeholder="Filter by Country"
                  value={form.getFieldValue("country")?.[0] || undefined}
                  onChange={(value) => {
                    form.setFieldsValue({ country: value ? [value] : [] });
                    setCountryFieldValue(value || "");
                    handleFormChange();
                    setCurrentPage(1);
                  }}
                >
                  {uniqBy(
                    countryList.map((c) => ({
                      label: c.countryname,
                      value: c.countryname,
                    })),
                    "value"
                  )?.map((option) => (
                    <Option key={option?.value} value={option?.value}>
                      {option?.label}
                    </Option>
                  ))}
                </BorderRadiusSelect>
              </Col>
            )}
          </AntRow>
        </Form>
        <div className="text-end pagination">
          <ButtonOutlined style={iconStyle}>
            <KeyboardArrowLeftIcon onClick={handlePreviousWeek} />
          </ButtonOutlined>
          <ButtonOutlined style={iconStyle}>
            <KeyboardArrowRightIcon onClick={handleNextWeek} />
          </ButtonOutlined>
        </div>
      </div>

      <TableContainer component={Paper}>
        <Table aria-label="collapsible table">
          <TableHead>
            <TableRow>
              <TableCell className="header-cell">Employee</TableCell>
              <TableCell className="header-cell" colSpan={5} align="left">
                {moment(weekDates[0]).format("MMMM DD")} -{" "}
                {moment(weekDates[4]).format("MMMM DD")}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className="header-cell" />
              {weekDates
                .filter(
                  (date) => moment(date).day() !== 0 && moment(date).day() !== 6
                ) // Exclude weekends
                .map((date, idx) => (
                  <TableCell key={idx} className="data-cell-header">
                    {moment(date).format("ddd DD")}
                  </TableCell>
                ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {/* ?.filter((row) => {
                  const user = userList.find(
                    (user) => user.userid === row.userId
                  );
                  return user?.statusid === "1"; // Only include users with statusid === "1"
                }
                ) */}
            {!isLoading &&
              paginatedData.map((row, idx) => (
                <>
                  <Row
                    key={row.userId}
                    row={row}
                    index={idx}
                    weekDates={weekDates.filter(
                      (date) =>
                        moment(date).day() !== 0 && moment(date).day() !== 6 // Exclude weekends
                    )}
                    dataList={dataList}
                    loading={isLoading}
                    userList={userList}
                    getData={fetchResorcePlanning}
                  />
                </>
              ))}
          </TableBody>
        </Table>
        {isLoading && (
          <Empty
            image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
            imageStyle={{ height: 60 }}
            description={<span>Fetching...</span>}
          ></Empty>
        )}
        {uniqDataList?.length === 0 && !isLoading && <Empty />}
      </TableContainer>

      <div className="w-100 mt-2 d-flex gap-2 align-items-center justify-content-center legend">
        <div className="legend-box available">{null}</div>
        <span>Available</span>
        <div className="legend-box booked">{null}</div>
        <span>Booked</span>
      </div>
      {!isLoading && (
        <div
          className="pagination-container"
          style={{ textAlign: "right", marginTop: "20px" }}
        >
          <Pagination
            {...paginationOptions}
            current={currentPage}
            total={dedupedData?.length} // <-- changed from filteredData?.length
            onChange={(page) => {
              setCurrentPage(page);
            }}
          />
        </div>
      )}
    </>
  );
}
const BorderRadiusSelect = styled(Select)`
  .ant-select-selector {
    border-radius: 20px !important;
  }
`;
